import { ClientOnly } from 'remix-utils/client-only'
import { Animation } from './animation.client'

export function Loading() {
	return <ClientOnly>{() => <Animation />}</ClientOnly>
}
